import { TrenitaliaLogo } from "../shared/components/TrenitaliaLogo";
import { TrenitaliaChat } from "../features/trenitalia-chat/components/TrenitaliaChat";
import { MessageUploadModal } from "../features/message-upload-modal/components/MessageUploadModal";
import { Snackbar } from "../features/snackbar/components/Snackbar";
import "./HomePage.css";

export const HomePage = ({
  isChatOpen,
  setIsChatOpen,
  isUploadModalOpen,
  setIsUploadModalOpen,
  onLogout,
}) => {
  return (
    <div className="app-container">
      {/* Background Image */}
      <img
        src={`${process.env.PUBLIC_URL}/background.jpeg`}
        alt="background"
        className="app-background"
      />

      {/* Overlay */}
      <div className="app-overlay"></div>

      <button type="button" className="logout-button" onClick={onLogout}>
        Logout
      </button>

      {/* Main Content */}
      <div className="app-content">
        <div className="hero">
          <div className="intro-card">
            <div className="intro-logo-container">
              <TrenitaliaLogo size={80} className="intro-logo" />
            </div>

            <h1 className="intro-title">AI Station Support</h1>

            <p className="intro-text">
              L'assistente virtuale intelligente di Trenitalia, progettato per
              fornirti supporto rapido e personalizzato
            </p>

            <button
              onClick={() => setIsChatOpen(true)}
              className="intro-button"
            >
              💬 Avvia Conversazione
            </button>
          </div>
        </div>
      </div>

      {/* Chat Component */}
      <TrenitaliaChat
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
      />

      {/* Modal Caricamento Messaggi */}
      <MessageUploadModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
      />

      <Snackbar />
    </div>
  );
};
